export default{sources:{avif:"__VITE_ASSET__fp1veqVj__ 400w",webp:"__VITE_ASSET__B0QrIcVO__ 400w"},img:{src:"__VITE_ASSET__KIYi5oDa__",w:400,h:500}};